import { queryOptions, useQuery } from '@tanstack/react-query';
import { useApiClient } from '../ApiProvider';
import { unwrap, type ApiClient } from '../client';
import type { components } from '../schema.gen';
import { queryKeys } from './keys';

export type Tenant = components['schemas']['Tenant'];

/** Branding, sign-in providers and features. Public, so Login can load it. */
export function tenantQuery(api: ApiClient) {
  return queryOptions({
    queryKey: queryKeys.tenant(),
    queryFn: () => unwrap(api.GET('/api/tenant')),
    staleTime: 5 * 60_000,
  });
}

export function useTenant() {
  return useQuery(tenantQuery(useApiClient()));
}
